/**
 * General toggle class.
 * Toggles data-state attribute.

 * toggler: click handler, controls the state.
 * togglee: container for toggleable content

 * data-togglerId = Control group. Can have multiple togglers, togglees
 * data-state = state of group, can be either passive or active
 * data-role = determines if togglee or toggler (only toggler gets bind handler)

 * html example toggler (can be anything, controls state)
 * <div data-togglerId="menu" data-role="toggler" data-state="passive"></div>

 * html example togglee (can be anything, state controlled by toggler)
 * <div class="menu"  data-togglerId="menu" data-role="togglee" data-state="passive"></div>
 */

export default class Toggle {
  constructor() {
    const toggler = document.querySelectorAll('[data-role=toggler]'); // gets all togglers to determine groups
    // doesn't do anything atm. prepared for future extension
    const groups = []; // gets all groups available on page

    /**
     * Loops over available togglers to determine groups
     * gets all group titles and checks if exists in array test
     * if it doesn't exist adds to groups array
     */
    toggler.forEach(toggleElm => {
      const groupTitle = toggleElm.dataset.togglerid; // toggleItem.attr('data-togglerId');

      if (!groups.includes(groupTitle)) {
        groups.push(groupTitle);
      }
    });

    /**
    * Loops over groups in array.
    * Determines group state (passive or active)
    * for each group gets available togglers
    * handles on click for each toggler in group
    * adds state to all elements in group
    */
    groups.forEach(groupId => {
      const group = document.querySelectorAll(`[data-togglerId=${groupId}]`);

      group.forEach(groupElm => {
        let state = groupElm.dataset.state;
        const role = groupElm.dataset.role;
  
        if (groupElm.dataset.role === 'toggler') {
          groupElm.addEventListener('click', (e) => {
            e.preventDefault();
            if (state === 'active') {
              state = 'passive';
            } else {
              state = 'active';
            }

            group.forEach(groupItem => {
              if (groupItem.dataset.role === 'togglee') {
                groupItem.dataset.state = state;
              }
            });
          })  
        }
      });
    });
  }
}